"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AlpineDistributorMap;
var js_api_loader_1 = require("@googlemaps/js-api-loader");
var loader = new js_api_loader_1.Loader({
    apiKey: 'AIzaSyAtYd_XvuxAVlM9A9XYY067oFBLn37iKlA',
    version: 'weekly',
    libraries: ['places', 'geocoding', 'marker', 'geometry'],
});
function AlpineDistributorMap() {
    return Alpine.data('distributorMap', function () { return ({
        API_URL: '',
        // state
        initialized: false, // component
        loading: false, //
        googleMapsReady: false, // google maps
        error: false,
        geocodingError: false,
        errorMessage: '',
        stateMessage: '',
        // dom values
        googleMapsPinIconPath: '',
        // form
        location: '',
        radius: 150,
        geocodedLocation: null,
        continents: [],
        results: [], // all distributors
        nearbyResults: [], // search results for front end
        continentResults: [], // search results for front end
        // google maps elements
        infoWindow: null,
        markers: [],
        // contact form details
        currentDistributorEmail: '',
        currentDistributor: '',
        init: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            console.log('init() started');
                            this.API_URL = '/graphql';
                            this.googleMapsPinIconPath = this.$root.dataset.gmapMarker;
                            this.stateMessage = 'Loading distributors';
                            if (!(this.$root.dataset.continents !== 'false')) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.findDistributorsByContinent()];
                        case 1:
                            _b.sent();
                            return [3 /*break*/, 5];
                        case 2:
                            // load all distributors
                            _a = this;
                            return [4 /*yield*/, this.graphQLRequest(this.graphQLQueryStringForAllDistributors)];
                        case 3:
                            // load all distributors
                            _a.results = _b.sent();
                            this.stateMessage = 'Loading map';
                            return [4 /*yield*/, this.initGmaps()];
                        case 4:
                            _b.sent();
                            this.googleMapsReady = true;
                            this.initialized = true;
                            this.stateMessage = '';
                            _b.label = 5;
                        case 5:
                            console.log('init() finished');
                            return [2 /*return*/];
                    }
                });
            });
        },
        findNearbyDistributors: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log('findNearbyDistributors() started');
                            this.error = false;
                            if (this.location.length < 3) {
                                console.log('findNearbyDistributors() requires min 3 characters');
                                this.loading = false;
                                return [2 /*return*/];
                            }
                            if (this.loading) {
                                console.log('findNearbyDistributors is busy, please wait');
                                return [2 /*return*/];
                            }
                            if (!(this.markers.length > 0)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.clearMarkers()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            // update state
                            this.loading = true;
                            this.currentDistributorEmail = '';
                            this.currentDistributor = '';
                            this.nearbyResults = [];
                            console.log('geocodeCurrentLocation() started');
                            return [4 /*yield*/, this.geocodeCurrentLocation()];
                        case 3:
                            _a.sent();
                            console.log('geocodeCurrentLocation() finished');
                            if (!!this.error) return [3 /*break*/, 6];
                            console.log('calculateDistances() started');
                            return [4 /*yield*/, this.calculateDistances()];
                        case 4:
                            _a.sent();
                            console.log('calculateDistances() finished');
                            console.log('plotLocations() started');
                            return [4 /*yield*/, this.plotLocations()];
                        case 5:
                            _a.sent();
                            console.log('plotLocations() finished');
                            _a.label = 6;
                        case 6:
                            this.$nextTick(function () {
                                _this.stateMessage = '';
                                _this.loading = false;
                                console.log('loading false');
                                if (_this.nearbyResults.length > 0) {
                                    _this.$refs.distributorResultsHeader.scrollIntoView();
                                }
                                console.log('element ready and in view');
                            });
                            return [2 /*return*/];
                    }
                });
            });
        },
        findDistributorsByContinent: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a, localConts;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            console.log('findDistributorsByContinent() started');
                            // update state
                            this.loading = true;
                            this.currentDistributorEmail = '';
                            this.currentDistributor = '';
                            this.continentResults = [];
                            // Sanitize the continents by converting the numbers within the JSON to strings.
                            JSON.parse(this.$root.dataset.continents).map(function (continent) {
                                _this.continents.push("\"".concat(continent.toString(), "\""));
                                return continent;
                            });
                            _a = this;
                            return [4 /*yield*/, this.graphQLRequest(this.graphQLQueryStringForAllDistributorsByContinents)];
                        case 1:
                            _a.results = _b.sent();
                            localConts = [];
                            // Create an array for each continent.
                            this.results.forEach(function (result) {
                                var continent = result.taxContinents.nodes[0].name;
                                if (!localConts[continent]) {
                                    localConts[continent] = {
                                        name: continent,
                                        results: [],
                                    };
                                }
                                localConts[continent].results.push(result);
                            });
                            // Now cycle through the local array and push the results to the main array.
                            if (localConts) {
                                Object.keys(localConts).forEach(function (continent) {
                                    _this.continentResults.push({
                                        name: continent,
                                        results: localConts[continent].results,
                                    });
                                });
                            }
                            this.$nextTick(function () {
                                _this.stateMessage = '';
                                _this.loading = false;
                            });
                            return [2 /*return*/];
                    }
                });
            });
        },
        initGmaps: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    return [2 /*return*/, new Promise(function (resolve) {
                            if (_this.googleMapsReady)
                                return; // check this
                            loader
                                .load()
                                .then(function (google) {
                                _this.map = new google.maps.Map(_this.$refs.distributorMapElement, {
                                    center: {
                                        lat: 39.8097343,
                                        lng: -98.5556199,
                                    },
                                    zoom: 5,
                                    mapTypeControl: false,
                                    // zoomControlOptions: {
                                    //   position: google.maps.ControlPosition.BOTTOM_RIGHT,
                                    // },
                                    streetViewControl: false,
                                });
                                _this.infoWindow = new google.maps.InfoWindow({
                                    content: 'InfoWindow',
                                });
                                _this.map.addListener('click', function () {
                                    _this.infoWindow.close();
                                });
                            })
                                .then(function () {
                                _this.googleMapsReady = true;
                                resolve();
                            }); // end then
                        })];
                });
            });
        },
        handleInfoWindowInquiryClick: function (e) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    this.currentDistributorEmail = e.detail.email;
                    this.currentDistributor = e.detail.name;
                    this.$nextTick(function () {
                        _this.$refs.distributorContactHeader.scrollIntoView();
                    });
                    return [2 /*return*/];
                });
            });
        },
        geocodeCurrentLocation: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    return [2 /*return*/, new Promise(function (resolve) {
                            _this.geocodingError = false;
                            var geocoder = new google.maps.Geocoder();
                            geocoder.geocode({ address: _this.location }, function (results, status) {
                                if (status === 'OK') {
                                    _this.geocodedLocation = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                                    resolve();
                                }
                                else {
                                    _this.error = true;
                                    _this.geocodingError = true;
                                    resolve();
                                }
                            });
                        })];
                });
            });
        },
        calculateDistances: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    return [2 /*return*/, new Promise(function (resolve) {
                            console.log('calculateDistances started');
                            _this.results.forEach(function (result) {
                                var currentLocation = new google.maps.LatLng(result.distributorFields.distributorLocation.latitude, result.distributorFields.distributorLocation.longitude);
                                var spherical = google.maps.geometry.spherical.computeDistanceBetween(_this.geocodedLocation, currentLocation);
                                result.distanceToLocation = Math.ceil(spherical * 0.000621371); /* eslint-disable-line */
                            });
                            console.log('calculateDistances finished');
                            resolve();
                        })];
                });
            });
        },
        plotLocations: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    return [2 /*return*/, new Promise(function (resolve) {
                            console.log('plotLocations started');
                            _this.nearbyResults = [];
                            var bounds = new google.maps.LatLngBounds();
                            _this.results.forEach(function (result) {
                                if (result.distanceToLocation <= _this.radius) {
                                    var currentLocation = new google.maps.LatLng(result.distributorFields.distributorLocation.latitude, result.distributorFields.distributorLocation.longitude);
                                    var marker_1 = new google.maps.Marker({
                                        position: new google.maps.LatLng(currentLocation),
                                        map: _this.map,
                                        icon: {
                                            url: _this.googleMapsPinIconPath,
                                            scaledSize: new google.maps.Size(30, 40),
                                        },
                                    });
                                    var infoWindow_1 = _this.infoWindow; /* eslint-disable-line */
                                    marker_1.addListener('click', function () {
                                        infoWindow_1.setContent("\n                <section class=\"p-12\" style=\"max-width: 420px;\">\n                  <h5 class=\"h5\">".concat((result.distributorFields.distributorDisplayName) ? result.distributorFields.distributorDisplayName : result.title, "</h5>\n                  <address>").concat(result.distributorFields.distributorAddress, "</address>\n                  <p class=\"mt-8 lg:mt-12\"><strong>Phone:</strong> <span>").concat(result.distributorFields.distributorTelephone, "</span></p>\n                  <p><strong>Email:</strong> <a href=\"mailto:").concat(result.distributorFields.distributorEmail, "\">").concat(result.distributorFields.distributorEmail, "</a></p>\n                  <div class=\"mt-12\">\n                    <button type=\"button\" onclick=\"window.dispatchEvent(new CustomEvent('view-distributor-on-list', { detail: {name: '").concat((result.distributorFields.distributorDisplayName) ? result.distributorFields.distributorDisplayName : result.title, "', email: '").concat(result.distributorFields.distributorEmail, "' } }))\" class=\"para-lg font-bold leading-none flex flex-row flex-nowrap items-center justify-between relative after:block after:content-[''] after:w-6 after:h-6 after:bg-block-text-color after:ml-4 after:mask-contain after:mask-no-repeat after:mask-center after:[mask-image:url('../images/icons/chevron-right.svg')] transition-colors duration-500 ease-in-out after:transition-all after:duration-500 after:ease-in-out hover:text-block-text-color-hover hover:after:translate-x-[2px] hover:after:bg-block-text-color-hover\">Inquire Now</button>\n                  </div>\n                </section>\n              "));
                                        infoWindow_1.open({
                                            anchor: marker_1,
                                            map: _this.map,
                                        });
                                    });
                                    _this.markers.push(marker_1);
                                    bounds.extend(marker_1.getPosition());
                                    _this.nearbyResults.push(result);
                                }
                            });
                            console.log('plotLocations finished');
                            if (_this.nearbyResults.length > 0) {
                                _this.map.fitBounds(bounds);
                                console.log('fitBounds finished');
                            }
                            if (_this.nearbyResults.length === 1 && _this.map.getZoom() > 15) {
                                _this.map.setZoom(10);
                            }
                            resolve();
                        })];
                });
            });
        },
        clearMarkers: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    return [2 /*return*/, new Promise(function (resolve) {
                            var m = Alpine.raw(_this.markers);
                            for (var i = 0; i < m.length; i += 1) {
                                m[i].setMap(null);
                            }
                            _this.markers = [];
                            resolve();
                        })];
                });
            });
        },
        handleInquiryClick: function (email, name) {
            var _this = this;
            var hiddenField = this.$refs.distributorForm.querySelector('.gform_wrapper input[type="hidden"]');
            if (email) {
                this.currentDistributorEmail = email;
            }
            else {
                this.currentDistributorEmail = 'noDistributorEmailSet@test.test';
            }
            this.currentDistributor = name;
            if (hiddenField) {
                hiddenField.value = this.currentDistributorEmail;
            }
            this.$nextTick(function () {
                _this.$refs.distributorContactHeader.scrollIntoView();
            });
        },
        handleFormSubmit: function (distributorLocation, distributorRadius) {
            if (distributorLocation.length > 3) {
                this.$dispatch('open-distributor-map', {
                    location: distributorLocation,
                    radius: parseInt(distributorRadius, 10),
                });
            }
        },
        handleError: function () {
            this.error = true;
        },
        /* eslint-disable */
        graphQLRequest: function (queryString) {
            return __awaiter(this, void 0, void 0, function () {
                var response, data;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, fetch(this.API_URL, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    query: queryString
                                }),
                            })];
                        case 1:
                            response = _d.sent();
                            return [4 /*yield*/, response.json()];
                        case 2:
                            data = _d.sent();
                            if (data.errors > 0) {
                                return [2 /*return*/];
                            }
                            if (((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.length) > 0 || ((_c = (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.contentNodes) === null || _c === void 0 ? void 0 : _c.nodes.length) > 0) {
                                return [2 /*return*/, data.data.contentNodes.nodes];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        },
        /* eslint-enable */
        // Getters
        get graphQLQueryStringForAllDistributors() {
            return "query GetAllDistributors {\n        contentNodes(where: {contentTypes: DISTRIBUTOR}, first: 999) {\n          nodes {\n            ... on Page_distributor {\n              id\n              title\n              featuredImage {\n                node {\n                  srcSet(size: LARGE)\n                  sourceUrl(size: LARGE)\n                });\n              });\n              distributorFields {\n                distributorAddress\n                distributorContactFormEmail\n                distributorDisplayName\n                distributorEmail\n                distributorTelephone\n                distributorLocation {\n                  latitude\n                  longitude\n                });\n              });\n            });\n          });\n        });\n      }";
        },
        get graphQLQueryStringForAllDistributorsByContinents() {
            return "query GetAllDistributors {\n        contentNodes(\n          where: {\n            contentTypes: DISTRIBUTOR, \n            taxQuery: {\n              taxArray: {\n                taxonomy: TAX_CONTINENT, \n                terms: [".concat(this.continents, "]\n              }); \n                relation: OR\n            });\n          }); \n          first: 999\n        ) {\n          nodes {\n            ... on Page_distributor {\n              id\n              title\n              featuredImage {\n                node {\n                  srcSet(size: LARGE)\n                  sourceUrl(size: LARGE)\n                });\n              });\n              distributorFields {\n                distributorAddress\n                distributorContactFormEmail\n                distributorDisplayName\n                distributorEmail\n                distributorTelephone\n                distributorLocation {\n                  latitude\n                  longitude\n                });\n              });\n              taxContinents(first: 1) {\n                nodes {\n                  id\n                  name\n                });\n              });\n            });\n          });\n        });\n      }");
        },
    }); });
}
